import Swal from "sweetalert2";
import { formatCurrency } from "../../../../../shared/utils/formatCurrency";
import i18n from "../../../../../shared/i18n/i18n";
import styles from "../../styles/addReceipt.module.css";

function getThemeColors() {
  const style = getComputedStyle(document.documentElement);
  return {
    bg:  style.getPropertyValue("--bg-card-alt").trim() || "#2a3545",
    clr: style.getPropertyValue("--text-primary").trim()  || "#e5ecf5",
  };
}

export function showAlertFavor(favor, moneda = "CRC") {
  const { bg, clr } = getThemeColors();
  const symbol = moneda === "USD" ? "$" : "₡";
  return Swal.mixin({
    icon: "warning",
    title: i18n.t("recibos.alertaFavor", { favor: `${symbol}${formatCurrency(favor)}` }),
    background: bg,
    color: clr,
    customClass: {
      icon: styles.customIconWarning,
    },
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
      const progressBar = toast.querySelector(".swal2-timer-progress-bar");
      if (progressBar) {
        progressBar.style.backgroundColor = "#f97316";
      }
    },
  });
}

export function showAlertErrorMonto() {
  const { bg, clr } = getThemeColors();
  return Swal.mixin({
    icon: "error",
    title: i18n.t("recibos.alertaSinMonto"),
    background: bg,
    color: clr,
    customClass: {
      icon: styles.customIconWarning,
    },
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
      const progressBar = toast.querySelector(".swal2-timer-progress-bar");
      if (progressBar) {
        progressBar.style.backgroundColor = "#f97316";
      }
    },
  });
}

export function showRestanteError() {
  const { bg, clr } = getThemeColors();
  return Swal.mixin({
    icon: "error",
    title: i18n.t("recibos.alertaTotalCero"),
    background: bg,
    color: clr,
    customClass: {
      icon: styles.customIconWarning,
    },
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
      const progressBar = toast.querySelector(".swal2-timer-progress-bar");
      if (progressBar) {
        progressBar.style.backgroundColor = "#f97316";
      }
    },
  });
}
